<template>
  <div style="padding: 10px 14px; text-align: right; direction: rtl">
    <h3>سلب المسؤولية</h3>
    <p>
      العزيز المستخدم، لاستخدام خدمة مكعب التعليم {{ activationCompany.abbreviation }}، يرجى قراءة بعناية اتفاقية المنع من المسؤولية هذه وفهم جميع شروطها. إلا إذا قرأت وأنتهكت
      وتقبلت جميع بنود الاتفاقية، فلا تقم بالشراء لهذا الخدمة.
      <strong>
        <u>
          عند النقر على "الموافقة" أو "التالي" أو عندما تقوم بالشراء أو الاستخدام أو أي سلوك آخر يدل على قبولك لهذه الاتفاقية، فسيعتبر ذلك بأنك قرأت واستمتعت بالاتفاقية وأنه
          ملف قانوني يربطك والشركة.
        </u>
      </strong>
    </p>
    <p>1. يوافق المستخدم ويتفهم أنه سنبذل جهدنا التجاري الصافي للحفاظ على أمان تخزين البيانات في هذا الخدمة البرمجيات، ولكننا لا نضمن ذلك بشكل كامل بما في ذلك ما يلي:</p>
    <p>（1） لن نكون مسؤولين عن حذف البيانات المرتبطة بخدمتنا البرمجيات الخاصة بك أو فشل تخزينها؛</p>
    <p>
      （2） لدينا الحق في تحديد أطول فترة تخزين بياناتك في البرنامج بناءً على الظروف الفعلية ومتطلبات القوانين واللوائح، ويمكنك إجراء النسخ الاحتياطي الخاص بك داخل تلك المساحة
      التخزينية حسب الحاجة. ومع ذلك، قد تعاني البيانات الموجودة في هذه المساحة من عدم القدرة على الحفاظ عليها تمامًا أو فقدانها أو الخطأ بسبب القيود المتواجدة في المساحة
      التخزينية أو الأسباب التقنية أو بيئات الأجهزة والأتصالات وغيرها من العوامل، ولن نكون مسؤولين عنها؛
    </p>
    <p>
      （3） إذاتوقفت عن استخدام وظائف وأحد خدماتنا أو تم إنهاؤها أو الإلغائها، سنحذف بياناتك من الخادم. ما لم تتطلب القوانين واللوائح المطبقة علينا أن نقوم بإعادة البيانات
      إليك بعد إنهاء الخدمة أو إيقافها أو إلغائها، فإننا ليس لدينا الالتزام بتقديم أي بيانات لك.
    </p>
    <p>نظرًا لأن الخدمات عبر الإنترنت لها طبيعة خاصة، لن نكون مسؤولين عن السلوك التالي الذي يتم تنفيذه بناءً على استراتيجية التشغيل والتوقعات للمستخدم:</p>
    <p>（1） توافق على أننا نملك الحق في تغيير أو انقطاع أو إيقاف بعض أو كل خدماتنا في أي وقت؛</p>
    <p>
      （2） لدينا الحق في القيام بمراجعة أو صيانة النظام أو الأجهزة التي نوفر فيها خدماتنا بشكل دوري وغير دوري، وإذا كان هناك انقطاع أو تعليق معقول لأجل ناجم عن مثل هذه
      الحالات، لن نكون مسؤولين عنه؛
    </p>
    <p>
      （3） قد يكون هناك اختلافات فيما يمكن للأعضاء في المناطق المختلفة استخدامه من خدماتنا البرمجيات المعينة بناءً على ترتيبات الاستراتيجية والمعدلات، وكل ما ذكر هو الأمر كما
      نقدمه 실제로 ولا نتحمل أي مسؤولية لذلك.
    </p>
    <p>
      2. نحن غير قادرين على ضمان دقة البيانات الواردة في مصدر البيانات وما إذا كانت قناة استلام البيانات مستمرة أم لا، وبالتالي لا نستطيع ضمان استمرارية و своевремانية ودقة
      الخدمات المقدمة. إذا وجدت بيانات غير دقيقة أو خطأ أو نقص في البيانات التي استلمتها وتحديثناها، يمكنك التواصل معنا أو مصدر البيانات الخاص بك للتحقق منها.
    </p>
    <p>
      3. لا تحتوي برنامجنا على أي رموز ضارة تستهدف تدمير بيانات الكمبيوتر الخاص بك والحصول على معلوماتك الشخصية. لقد تم اختبار البرنامج بدقة، لكننا لا نضمن توافقه مع جميع
      أنظمة البرمجيات والأجهزة ولا نضمن أن البرنامج حرٍ من الأخطاء. إذا حدثت مشاكل في التوافق أو وجود أخطاء في البرنامج، يمكنك الاتصال بخدمة الدعم الفني حتى نتمكن من تقديم
      الدعم. إذا لم نتمكن من حل مشكلة التوافق، يمكنك حذف البرنامج.
    </p>
    <p>
      4. ضمن نطاق القانون السائد أقصاه، لن نكون مسؤولين عن أي ضرر أو مخاطرة نتج عنها استخدامك أو عدم استعمالك لهذا البرنامج بما في ذلك، وليس حصراً عليه، الضرر الشخصي المباشر
      أو غير المباشر، فقدان الأرباح التجارية، انقطاع التجارة، فقدان معلومات الأعمال، أو أي خسائر اقتصادية أخرى.
    </p>
    <p>
      5. إذا انتهكت أحكام هذه الاتفاقية وتسبب لنا خسائر، فأنا لديه الحق في اتخاذ إجراءات تشمل، ولكن ليست محصورة بها، تقيد إذن الاستخدام، وإيقاف تقديم الخدمة، وتقييد الاستخدام،
      واتخاذ إجراءات قانونية.
    </p>
    <p>
      6. إذا كنت قد شكويت شخصًا أو شكوتك شخصًا آخر، فإليك الحق في توفير معلومات ذات صلة بالموضوع والمعلومات الاتصالية والمحتوى الشكوى إلى الجهة المعنية أو الجهات الرسمية
      الأخرى لتوفير الحلول للشكوى والاستجابة بأسرع وقت ممكن لحماية حقوق الجميع.
    </p>
    <p>7. لن نكون مسؤولين عن عدم قدرتنا على تقديم الخدمة بشكل طبيعي بسبب الأسباب التالية:</p>
    <p>（1） خلال فترة الصيانة والإصلاحات اللازمة لنظامنا;</p>
    <p>（2） حال حدوث عطل في برامج الكمبيوتر والهواتف الذكية والخطوط الاتصالية والكهرباء لديك;</p>
    <p>（3） استخدامك غير صحيح للبرنامج أو استخدامك له بطريقة غير مصرح بها من قبلنا;</p>
    <p>（4） بسبب عدم استقرار الإشارات اللاسلكية، مما يؤدي إلى فشل تسجيل الدخول في الخدمة ونقص في تحديث البيانات;</p>
    <p>（5） بسبب الفيروسات والبرامج الضارة والبرامج الخبيثة وازدحام الشبكة وعدم استقرار النظام وعيوب الجهاز ومشاكل الاتصال ووقف الكهرباء أو الأفعال الحكومية;</p>
    <p>（6） بسبب هجمات الاختراق وتغييرات تقنية أو أعطال من قبل مزودي الشبكة وترقيات الموقع والمشكلات المتعلقة بالنظام، مما يتسبب في الانقطاع أو التأخير في خدمات البرنامج;</p>
    <p>（7） بسبب تعديلات تقنية من قبل شركة الاتصالات مما يجعل الخدمة متوقفة أو محظورة;</p>
    <p>（8） بسبب سياسات الحكومة التي تجعل الخدمة مؤقتًا محظورة;</p>
    <p>رغم ما سبق، سوف نتخذ إجراءات معقولة للمساعدة في استعادة الخدمة بأسرع وقت ممكن.</p>
    <p>8. لن نكون مسؤولين عن أي من الأمور غير القابلة للتوقع والتي تمنع نظام خدمات البرنامج من العمل بما في ذلك:</p>
    <p>
      (1) تتفق على أنه أثناء استخدامك لهذه الخدمة، قد تواجه عوامل غير متوقعة مثل الكوارث الطبيعية كالحرائق والأرض الزلازل وبوباء الأمراض والعواصف وكذلك الأحداث الاجتماعية مثل
      الحرب والفوضى والأفعال الحكومية وبوباء الأمراض. عند حدوث مثل هذه الحالات، سنسعى للعمل مع الوحدات ذات الصلة للقيام بذلك بأسرع وقت ممكن، ولكن لن نكون مسؤولين عن الخسائر
      الناجمة عن ذلك باعتبار القانون السائد أقصاه.
    </p>
    <p>
      (2) تتفق على أنه كبرنامج على الإنترنت، قد يكون متأثر بعوامل مختلفة بما في ذلك، وليس حصراً عليه، سبب المستخدم ومستوى خدمة الشبكة والبيئة الاجتماعية كذلك قد يكون معرضًا
      للتهديدات الأمنية بما في ذلك، وليس حصراً عليه، استخدام الآخرين لمعلومات المستخدم بشكل غير قانوني لإزعاجك في الواقع؛ وقد تكون البرامج الأخرى التي قمت بتنزيلها وتثبيتها أو
      المواقع الإلكترونية التي زرتها تحتوي على فيروسات وأشياء ضارة أخرى، مما يشكل خطراً على أمان معلوماتك وأبيانك على جهازك مما يؤثر على استخدامك الطبيعي للبرنامج. لذلك يجب
      عليك زيادةوعي الأمان المعلوماتي واوعي معلوماتك الشخصية وكيفية حمايتها من الوقوع في الخسائر.
    </p>
    <p>
      9. تتفق على أنه أثناء استخدامك لهذه الخدمة، قد تواجه خطرًا ناجمًا عن المعلومات عبر الإنترنت أو سلوك المستخدمين الآخرين، ولن نكون مسؤولين عن صحة أو примениته أو قانونية
      أي معلومة، ولن نكون مسؤولين عن أي ضرر نتج عنه الغرامات أو الاستغلالات الأخرى. هذه الخطرات تشمل، وليس حصراً عليها:
    </p>
    <p>(1) المعلومات التي تحتوي على تهديدات أو تحقيرات أو شيء غير مرغوب فيه أو غير قانوني من قبل الأشخاص الآخرين الذين يستخدمون أسماءهم بشكل غير حقيقي أو دون إذن؛</p>
    <p>(2) تعرضك للخداع أو الاستغلال أو أي آثار نفسية أو جسدية أو مالية أخرى نتيجة لذلك؛</p>
    <p>(3) أي خطر آخر ناجم عن المعلومات عبر الإنترنت أو سلوك المستخدمين الآخرين.</p>
    <p>
      10. في أي حالة، يجب عليك عدم الثقة البسيطة في أي رسائل حول القروض أو طلب كلمات المرور أو أي معلومات متعلقة بالأموال. بالنسبة لأي عمليات مالية، تحقق دائمًا من هوية الشخص
      الآخر واحذر دائمًا من إشعاراتنا حول كيفية الوقاية من الجريمة المالية.
    </p>
    <p>الشركة: {{ activationCompany.company }}</p>
    <p>الهاتف: 400-632-8880</p>
    <p>اسم جهة الاتصال: ممثل خدمة العملاء</p>
    <p>العنوان: {{ activationCompany.address }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activationCompany: {
        company: 'شركة أنداو مواد تصميم الضوء الإلكتروني المصنعة في مدينة دولتي شان غوانغ đông',
        address: 'منطقة مركز مجمع المال الدولي في مدينة دولتي شان غوانغ đông، جمهورية الصين الشعبية، المبنى 11، المنطقة C، المدرج A',
        abbreviation: 'أنداو'
      }
    }
  }
}
</script>
